/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable @next/next/no-img-element */
import * as React from 'react';

import Image from 'next/image';

import CollectionsOutlinedIcon from '@mui/icons-material/CollectionsOutlined';
import { Button } from '@mui/material';

import { track } from '@hbf/analytics';

import NoListingImage from '@kamernet/assets/no-listing-image.webp';
import { ONE_PIXEL_BLURRED_PLACEHOLDER_IMAGE } from '@kamernet/constants/Common';
import { AnalyticsEvent } from '@kamernet/core/Analytics/types';
import { useIntl } from '@kamernet/core/Intl';
import { getImageUrl } from '@kamernet/utilities/Resources/getImageUrl';

import { ListingDetailsContext } from '../../ListingDetailsContext';

import styles from './Gallery.module.css';

export interface GalleryProps {
  onOpenLightBox: () => void;
}

export const Gallery = ({ onOpenLightBox }: GalleryProps) => {
  const { listingDetails } = ListingDetailsContext.useContext();
  const { T } = useIntl();

  const onOpenLightbox = React.useCallback(() => {
    onOpenLightBox();
    track(AnalyticsEvent.ClickedGalleryLDP);
  }, [onOpenLightBox]);

  return (
    <section className={styles.root}>
      <div className={styles.aspectRatioBox}>
        <Image
          src={getImageUrl(listingDetails.imageList?.[0]) || NoListingImage.src}
          alt={`show all photos of ${listingDetails.computedStreetName}`}
          className={styles.image}
          layout="fill"
          objectFit="cover"
          priority
          placeholder="blur"
          blurDataURL={ONE_PIXEL_BLURRED_PLACEHOLDER_IMAGE}
          onClick={onOpenLightbox}
        />
        <div className={styles.imageOverlay} />
        <Button
          variant="outlined"
          className={styles.button}
          startIcon={<CollectionsOutlinedIcon />}
          onClick={onOpenLightbox}
        >
          {T('LBL_SHOW_ALL')}
        </Button>
      </div>
    </section>
  );
};
